import apiClient from '../../../services/apiClient';

/**
 * Solitaire (Klondike draw-1) mission API (v1.43.0, server-authoritative, the client only sends actions).
 * Contract: .claude/lair-feature/SPEC_V141_GAMES.md §12 / SolitaireStateDTO.
 * GET / POST return { state, events, run }:
 *   state  — { tableau:[{down, up:[{r,s}]}]×7, stock, wasteCount, waste:[{r,s}] (≤3, last = top),
 *              foundations:[{r,s}|null]×4 (S,H,D,C), foundationCount, thresholds:[1★,2★,3★],
 *              movesLeft, movesTotal, movesBonus, recycles, result: null|'WIN'|'LOSE', stars,
 *              hint: {action, from, to}|null }
 *            face-down cards are never sent — only their count per column and the stock size
 *   events — draw, recycle, move, flip, finish, end, timeout ([] on GET)
 *   run    — MissionRunDTO with rewards once the game is over, else null
 */
export const solitaireAPI = {
  // GET /v1/missions/runs/{runId}/solitaire[?hint=1]
  getGame: async (runId, { hint } = {}) => {
    const url = `/v1/missions/runs/${runId}/solitaire`;
    const response = hint ? await apiClient.get(url, { params: { hint: 1 } }) : await apiClient.get(url);
    return response.data;
  },
  // POST /v1/missions/runs/{runId}/solitaire {action, from?, to?} — 422 if the action is illegal
  act: async (runId, body) => {
    // an illegal move is a normal game event — no global alert, the page shows a soft hint
    const response = await apiClient.post(`/v1/missions/runs/${runId}/solitaire`, body, { silentError: true });
    return response.data;
  },
  draw: (runId) => solitaireAPI.act(runId, { action: 'DRAW' }),
  move: (runId, from, to) => solitaireAPI.act(runId, { action: 'MOVE', from, to }),
  auto: (runId) => solitaireAPI.act(runId, { action: 'AUTO' }),
  finish: (runId) => solitaireAPI.act(runId, { action: 'FINISH' }),
  // GET /v1/game/runs/{runId}/hero → { characterId, character, look }
  getHero: async (runId) => {
    const response = await apiClient.get(`/v1/game/runs/${runId}/hero`);
    return response.data;
  },
};

export default solitaireAPI;
